import MapLayout from "layout/MapLayout";
import EditMapPage from "pages/map/EditMapPage";
import LiveStcmMapPage from "pages/map/LiveStcmMapPage";
import MapEditorPage from "pages/map/MapEditorPage";
import MapPage from "pages/map/MapPage";
import Providers from "providers/Providers";
import ControlDebugProvider from "providers/debug/ControlDebugProvider";
import LandmarksProvider from "providers/navigation/LandmarksProvider";
import MapManagerProvider from "providers/navigation/MapManagerProvider";
import MapProvider from "providers/navigation/MapProvider";
import MissionControlProvider from "providers/navigation/MissionProvider";
import MissionExecutionProvider from "providers/navigation/MissionExecutionProvider";
import NavigateToPoseProvider from "providers/navigation/NavigateToPoseProvider";
import TempMissionProvider from "providers/navigation/TempMissionProvider";

export const mapRoutes = {
    path: "map",
    element: (
        <Providers
            key="Map-provider"
            providers={[
                MapProvider,
                ControlDebugProvider,
                LandmarksProvider,
                TempMissionProvider,
                MapManagerProvider,
                MissionControlProvider,
                MissionExecutionProvider,
                NavigateToPoseProvider,
            ]}
        >
            <MapLayout />
        </Providers>
    ),
    children: [
        {
            index: true,
            element: <MapPage />,
        },
        {
            path: "live",
            element: <LiveStcmMapPage />,
        },
        {
            path: "edit",
            element: <EditMapPage />,
        },
        {
            path: "editor",
            element: <MapEditorPage />,
        },
    ],
};
